import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { consultSchema, conversation, conversations } from 'Schemas/schemas';

import { getEntities } from './common';

export const getConsultGroupIds = state => state.webChat.conversation.ids;

export const getConversationsByActiveClinic = state => {
  const clinicId = state.webChat.commons.activeClinicTab;
  if (!clinicId) return [];
  return state.webChat.conversation.clinicConversations?.[clinicId]?.ids || [];
};

export const getConsultHistoryIds = state => state.webChat.consultHistory.ids;

// export const getConsults = (entities, ids) => denormalize(ids, [conversations], entities);
export const getConsultGroups = (entities, ids) => denormalize(ids, conversations, entities);
export const getFullConsultGroups = entities =>
  denormalize(
    Object.keys(entities?.conversation || {}).map(e => parseInt(e, 10)),
    conversations,
    entities,
  );

export const denormalizeConversations = createSelector(
  [getEntities, getConsultGroupIds],
  getConsultGroups,
);

export const denormalizeConversationsByActiveClinic = createSelector(
  [getEntities, getConversationsByActiveClinic],
  getConsultGroups,
);

export const denormalizeFullConsultGroups = createSelector([getEntities], getFullConsultGroups);

export const getConversationByIds = createSelector(
  [getEntities],
  entities => ids => denormalize(ids, conversations, entities),
);

export const getConsultsHistory = createSelector(
  [getEntities, getConsultHistoryIds],
  (entities, ids) => denormalize(ids, [consultSchema], entities),
);

export const getConsultById = createSelector([getEntities, (state, id) => id], (entities, id) =>
  denormalize(id, consultSchema, entities),
);

export const getConversationById = createSelector(
  [getEntities, (state, id) => id],
  (entities, id) => denormalize(id, conversation, entities),
);

export const denormalizeConsults = ids =>
  createSelector([getEntities], entities => denormalize(ids, [consultSchema], entities));
